export default {"src":"/_next/static/media/heartWithPaw_64.e492e180.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};